var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.03125C9.63281 7.03125 9.84375 7.24219 9.84375 7.5C9.84375 7.75781 9.63281 7.96875 9.375 7.96875H3.75C3.49219 7.96875 3.28125 7.75781 3.28125 7.5C3.28125 7.24219 3.49219 7.03125 3.75 7.03125H9.375ZM0 2.8125C0 1.77686 0.839356 0.9375 1.875 0.9375H11.25C12.2842 0.9375 13.125 1.77686 13.125 2.8125V12.1875C13.125 13.2217 12.2842 14.0625 11.25 14.0625H1.875C0.839356 14.0625 0 13.2217 0 12.1875V2.8125ZM0.9375 2.8125V12.1875C0.9375 12.7061 1.35732 13.125 1.875 13.125H11.25C11.7686 13.125 12.1875 12.7061 12.1875 12.1875V2.8125C12.1875 2.29482 11.7686 1.875 11.25 1.875H1.875C1.35732 1.875 0.9375 2.29482 0.9375 2.8125Z",
    fill: "#F31C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.dfc236ac1bd818dcadbd5253554e6074.svg";
export { ForwardRef as ReactComponent };